/** Editor roster from billing/plan.seats.editors with legacy billingSeats fallback. */

export function editorsFromPlanAndLegacy(planData, legacySeatDocs) {
  const raw = planData?.seats?.editors;
  if (raw && typeof raw === 'object' && !Array.isArray(raw)) {
    const keys = Object.keys(raw);
    if (keys.length > 0) {
      return keys.map((id) => ({
        id,
        ...(typeof raw[id] === 'object' && raw[id] ? raw[id] : {}),
      }));
    }
  }
  if (!legacySeatDocs) return [];
  const docs = Array.isArray(legacySeatDocs) ? legacySeatDocs : legacySeatDocs.docs || [];
  return docs.map((d) => ({
    id: d.id,
    ...(typeof d.data === 'function' ? d.data() || {} : d),
  }));
}
